__turbopack_context__.v({
  "iframe": "YoutubeVideo-module-scss-module__DVMIJW__iframe",
  "livechat": "YoutubeVideo-module-scss-module__DVMIJW__livechat",
  "wrapper": "YoutubeVideo-module-scss-module__DVMIJW__wrapper",
});
